var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { useAccordionState, useAccordionDispatch } from './AccordionProvider';
import { ChevronUp } from 'pcln-icons';
import { Flex, IconButton } from 'pcln-design-system';
var TriggerContainer = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: ", "px;\n  cursor: pointer;\n"], ["\n  line-height: ", "px;\n  cursor: pointer;\n"])), function (_a) {
    var size = _a.size;
    return size;
});
var ChevronButton = styled(IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), function (_a) {
    var shouldAnimate = _a.shouldAnimate;
    return (shouldAnimate ? 'transition: transform 0.4s;' : null);
}, function (_a) {
    var open = _a.open;
    return (open ? null : 'transform: rotate(180deg);');
});
var AccordionTrigger = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? 'text' : _c, _d = _a.iconMR, iconMR = _d === void 0 ? 2 : _d, _e = _a.hideIcon, hideIcon = _e === void 0 ? false : _e, props = __rest(_a, ["children", "size", "color", "iconMR", "hideIcon"]);
    var _f = useAccordionState(), open = _f.open, shouldAnimate = _f.shouldAnimate;
    var dispatch = useAccordionDispatch();
    function onClick() {
        dispatch('toggle');
    }
    return (React.createElement(TriggerContainer, { alignItems: 'center', onClick: onClick },
        !hideIcon && (React.createElement(ChevronButton, __assign({}, props, { mr: iconMR, icon: React.createElement(ChevronUp, { size: size, color: color }), open: open, shouldAnimate: shouldAnimate, "aria-label": 'Toggle accordion state', "aria-expanded": !!open }))),
        children));
};
export default AccordionTrigger;
var templateObject_1, templateObject_2;
//# sourceMappingURL=AccordionTrigger.js.map